import { ApiFactoryClients } from "../api.types";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  getList: (): Promise<any[]> =>
    codeHttpClient
      .get("/notifications/")
      .then(({ data }) => (Array.isArray(data) ? data : [])),
  getUnreadCount: (): Promise<number> =>
    codeHttpClient
      .get("/notifications/unread-count")
      .then(({ data }) => data?.count ?? 0),
  markRead: (id?: number) =>
    codeHttpClient.put("/notifications/read" + (id ? `?id=${id}` : "")),
});
